module.exports = __webpack_public_path__ + "img/lasting_couples_heart_icon.c832d744.svg";